var map = {
	"./busd.svg": 2086,
	"./crypto-pending.png": 2087,
	"./crypto-reject.png": 2088,
	"./crypto-success.png": 2089,
	"./direpay.svg": 2090,
	"./trx.svg": 2091,
	"./usdc.svg": 2092,
	"./usdt.svg": 2093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;